import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { InterfaceSettingsUserColumns } from '@app/modules/table/table.interface';
import { defaultConfig, EmojiUrlFn } from '@components/emoji-picker/emoji-picker.interface';
import { EmojiPickerService } from '@components/emoji-picker/emoji-picker.service';

interface IItem {
    name: string;
    color: string;
    emoji: string;
}

/**
 * Компонент, отвечающий за рендер ячеек в табличном движке, для ячеек с типом данных "Список".
 * Используется в родительском table.component для снижения громоздкости.
 */
@Component({
    selector: 'app-table-cell-list',
    templateUrl: './list-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellListComponent implements OnInit {
    private readonly emojiPickerService = inject(EmojiPickerService);
    private readonly emojiUrlFn: EmojiUrlFn = this.emojiPickerService.getEmojiUrlFn(defaultConfig);

    @Input() column: InterfaceSettingsUserColumns;
    @Input() row: any;

    items: IItem[] = [];

    ngOnInit() {
        if (typeof this.row[this.column.name + '_with_decorations'] === 'object') {
            this.items = this.row[this.column.name + '_with_decorations'] as IItem[];
        } else if (this.column.cell(this.row)) {
            this.items = [{ name: this.column.cell(this.row), emoji: null, color: null }];
        }
    }

    getColor(item: IItem) {
        return !item.color ? '#d4d4d4' : `#${item.color}`;
    }

    getIcon(item: IItem): string | null {
        return !this.hasIcon(item) ? null : this.emojiUrlFn(item.emoji);
    }

    hasIcon(item: IItem) {
        return !!item.emoji;
    }
}
